export default __webpack_public_path__ + "static/media/doc.dab1d47f.png";